import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

import { useI18n } from 'vue-i18n'

export function useTimer(startSeconds, msgKey) {
	const { t } = useI18n();
	const done = ref(false);
	const secondsLeft = ref(startSeconds);
	const endTime = ref(null);
	const updateSecondsLeft = () => {
		const now = new Date().getTime();
		secondsLeft.value = Math.max(0, (endTime.value - now) / 1000);
		done.value = secondsLeft.value === 0;
	}
	const reset = seconds => {
		if (seconds === undefined) {
			seconds = startSeconds;
		}
		done.value = false;
		endTime.value = new Date().getTime() + seconds * 1000;
		updateSecondsLeft();
	};
	reset();
	const minutesLeftDisplay = computed(() => t(msgKey, Math.ceil(secondsLeft.value / 60)));
	const timer = ref(null);
	onMounted(() => {
		timer.value = setInterval(() => {
			if (!done.value) {
				updateSecondsLeft();
			}
		}, 5000);
	})
	onBeforeUnmount(() => clearInterval(timer.value));
	return {
		done,
		minutesLeftDisplay,
		reset,
	};
}
